// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"_wCTNGOM6","badge":"_-lrX1nZl","active":"_B6DqhVCo","inactive":"_K5iAsr7X"};